import React from "react";
import ComponentCircleLoader from "./utils/Loader/ComponentCircleLoader";

const Skeleton = () => (
    <ComponentCircleLoader />
) 

export default Skeleton